/**
 * Focus Reset Lesson
 * Skill Area: Foundations
 * Regain clarity with a quick mental reset
 */

import type { LessonDefinition } from '../types';
import {
  FOCUS_RESET_AI_PROMPT,
  FOCUS_RESET_CONTEXT_SCENARIOS,
} from '../prompts/focus-reset.prompt';

export const focusReset: LessonDefinition = {
  id: 'focus-reset',
  title: 'Focus Reset',
  displayTitle: 'Regain Clarity with a Quick Mental Reset',
  subTitle: 'Clear the noise before you dive back in.',
  tagline: 'Clear the noise before you dive back in.',
  persona: 'Lyra',
  skillArea: 'Foundations',
  format: 'reflection',
  difficulty: 'Beginner',
  estimatedMinutes: 6,
  tags: ['reset', 'breathing', 'intentionality'],
  dailyEligible: true,
  releasedAt: '2025-02-22T00:00:00.000Z',
  route: '/micro/focus-reset',
  storyBeat: 'Lyra helps you pause, breathe, and pick the next tiny move.',
  contextTitle: 'Reset starter',
  contextSummary:
    'Pick the moment that matches your day and Lyra will help you calm the swirl, name the priority, and move forward.',
  contextScenarios: FOCUS_RESET_CONTEXT_SCENARIOS,
  introPrompt:
    "When you're scattered, working harder just amplifies the chaos. I'll explain the value of a Reset, show you a comparison, and help you find one priority.",
  steps: [
    'Name the distraction triggering you',
    'See a "Spiral vs. Reset" comparison',
    'Pick one tiny move to get back on track',
  ],
  promptGuidance: 'Choose a trigger below or type your own.',
  aiPrompt: FOCUS_RESET_AI_PROMPT,
  inputPlaceholder: "Type 'Overwhelmed' or your own trigger...",
  quickPrompts: ['Inbox Avalanche', 'Meeting from Hell', 'Brain Fog'],
};
